/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import classNames from 'classnames';
import React from 'react';
import { SingleValue } from 'react-select';
import { SelectOption, UDSelect } from 'ud-form/components/select/component';
import type { UDSelectProps } from 'ud-form/components/select/component/select';
import overrideSelectComponents from 'ud-form/components/select/component/override';
import * as S from 'ud-form/components/select/component/styles';
import Label from 'ud-ui/components/label';
import UDText from 'ud-ui/components/text';
import { DivProps } from 'typings';

const optionHoverStyles = css`
  &:hover {
    background-color: #fffbeb;
  }
`;

interface UDFormLabeledSelectProps extends Omit<DivProps, 'onChange'> {
  headerText: string;
  onChange?: (value: { label: string | number | JSX.Element; value: string } | undefined) => void;
  options: { label: string; value: string }[];
  value?: { label: string; value: string };
  disable?: boolean;
  /** Своя разметка подписи — и в пункте меню, и в выбранном значении (иконка, флаг рядом с текстом). */
  formatOptionLabel?: (option: { label: string; value: string }) => React.ReactNode;
}

/** Подписанный сверху выпадающий список — вне Formik, для фильтров и панелей. */
function UDFormLabeledSelect(props: UDFormLabeledSelectProps) {
  const { headerText, options, value, onChange, disable, formatOptionLabel, ...rest } = props;

  const onChangeComponent = (newValue: SingleValue<SelectOption<string, string>>) => {
    if (!onChange) {
      return;
    }
    if (!newValue) {
      return;
    }
    onChange({ label: newValue.label, value: newValue.value });
  };

  const changedStyles = { ...overrideSelectComponents };
  changedStyles.Option = (props: any) => {
    const className = classNames('flex items-center justify-between px-4', props.isMulti ? 'py-1' : 'py-2');

    return (
      <S.Option css={optionHoverStyles} {...props.innerProps} className={className}>
        <UDText type="subhead">{props.children}</UDText>
        {props.isMulti && <S.OptionCheckbox data-checked={props.isSelected} />}
      </S.Option>
    );
  };

  return (
    <div {...rest}>
      <Label text={headerText}>
        <UDSelect
          isDisabled={disable}
          isMulti={false}
          options={options}
          value={value}
          onChange={onChangeComponent}
          formatOptionLabel={formatOptionLabel as UDSelectProps<false>['formatOptionLabel']}
          components={changedStyles}
        />
      </Label>
    </div>
  );
}

export default UDFormLabeledSelect;
